import { LegacyArchivedVehiclesPanel } from "@/components/organisms/Vehicles/LegacyMyVehicles/LegacyArchivedVehiclesPanel";

export const LegacyArchivedVehicles = () => {
  return <LegacyArchivedVehiclesPanel />;
};
